"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangedModuleStats = void 0;
/* eslint-disable require-jsdoc */
const firestore_1 = require("firebase/firestore");
const types_1 = require("../main/types");
const date_and_time_1 = __importDefault(require("date-and-time"));
const constants_1 = require("../main/constants");
class RangedModuleStats extends types_1.RangedModuleStatsType {
    constructor(moduleId, range, startDate) {
        super(moduleId);
        // santinize start date based on range
        let date;
        let dateString;
        switch (range) {
            case types_1.UserStatsRange.Daily:
                date = new Date(startDate.toDate().getFullYear(), startDate.toDate().getMonth(), startDate.toDate().getDate());
                dateString = date_and_time_1.default.format(date, "YYYY-MM-DD");
                break;
            case types_1.UserStatsRange.Monthly:
                date = new Date(startDate.toDate().getFullYear(), startDate.toDate().getMonth(), 1);
                dateString = date_and_time_1.default.format(date, "YYYY-MM");
                break;
            case types_1.UserStatsRange.Yearly:
                date = new Date(startDate.toDate().getFullYear(), 1, 1);
                dateString = date_and_time_1.default.format(date, "YYYY");
                break;
        }
        // assign id based on format;
        // daily doc id: 2022-12-15-FREN19
        // monthly doc id: 2022-12-FREN19
        // yearly doc id: 2022-FREN19
        this.startDate = firestore_1.Timestamp.fromDate(date);
        this.id = `${dateString}-${moduleId.toUpperCase()}`;
    }
}
exports.RangedModuleStats = RangedModuleStats;
RangedModuleStats.converter = {
    toFirestore(data) {
        return {
            startDate: data.startDate,
            moduleId: data.moduleId,
            highestCorrectStreak: data.highestCorrectStreak,
            studyTime: data.studyTime,
            rightAcquisitionCount: data.rightAcquisitionCount,
            wrongAcquisitionCount: data.wrongAcquisitionCount,
            rightReviewCount: data.rightReviewCount,
            wrongReviewCount: data.wrongReviewCount,
            rightPracticeCount: data.rightPracticeCount,
            wrongPracticeCount: data.wrongPracticeCount
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const path = snapshot.ref.path;
        const collectionName = path.split("/")[2];
        let range = types_1.UserStatsRange.Daily;
        switch (collectionName) {
            case constants_1.constants.COLLECTION_PATH_DAILY_MODULE_STATS:
                range = types_1.UserStatsRange.Daily;
                break;
            case constants_1.constants.COLLECTION_PATH_MONTHLY_MODULE_STATS:
                range = types_1.UserStatsRange.Monthly;
                break;
            case constants_1.constants.COLLECTION_PATH_YEARLY_MODULE_STATS:
                range = types_1.UserStatsRange.Yearly;
                break;
        }
        const startDate = documentData.startDate;
        const moduleId = documentData.moduleId;
        const data = new RangedModuleStats(moduleId, range, startDate);
        data.highestCorrectStreak = documentData.highestCorrectStreak;
        data.studyTime = documentData.studyTime;
        data.rightAcquisitionCount = documentData.rightAcquisitionCount;
        data.wrongAcquisitionCount = documentData.wrongAcquisitionCount;
        data.rightReviewCount = documentData.rightReviewCount;
        data.wrongReviewCount = documentData.wrongReviewCount;
        data.rightPracticeCount = documentData.rightPracticeCount;
        data.wrongPracticeCount = documentData.wrongPracticeCount;
        return data;
    }
};
